import React from 'react';
import { Box, Typography } from '@mui/material';

import Description from 'components/CareSummary/Description';
import Empty from 'components/CareSummary/Empty';
import Title from 'components/CareSummary/Title';
import { Container } from 'shared-components/Container';
import { useGetProfileParticipantTasksQuery, useGetProfileParticipantTaskQuery } from 'store/api/pkd/endpoints/participantTask';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { TaskTitles } from 'utils/enum';
import { ChartTextSkeleton } from '../ChartSkeleton';
import { getComorbidities } from './utils';

const OtherComorbidities = () => {
  const { isPersonLoading, isPersonAttributesFetching, person, personId, personAccountProfileId } =
    useGetPersonAndAttributes();

  const { participantTask, isParticipantTaskLoading } =
    useGetProfileParticipantTasksQuery(
      { personAccountProfileId },
      { skip             : !personAccountProfileId ,
        selectFromResult : ({ data = [], isFetching }) => ({
          participantTask          : data?.find(item => item.taskTitle === TaskTitles.coreQuestionnaire),
          isParticipantTaskLoading : isFetching,
        }),
      }
    );
   
  const { data:coreQuestionnaire, isLoading:isCoreQuestionnaireLoading } =
    useGetProfileParticipantTaskQuery(
      { personAccountProfileId, participantTaskId: participantTask?.id },
      { skip: !participantTask }
    );
  const comorbidities = getComorbidities(coreQuestionnaire);
  const isLoading = isPersonLoading || isCoreQuestionnaireLoading || isParticipantTaskLoading;

  const content = isLoading
    ? (
      <ChartTextSkeleton />
    )
    : comorbidities && comorbidities.length > 0
      ? (
        <Box
          m='20px 0px' display='flex' flexDirection='column' data-testid='mock-container'>
          {comorbidities.map((comorbidity) => (
            <Typography
              key={comorbidity} variant='pl1'>
              {comorbidity}
            </Typography>
          ))}
        </Box>
      )
      : (
        <Empty
          description='Fill out the Core Questionnaire'
          to={`/questionnaire/${coreQuestionnaire?.participantTaskId}`}
          buttonText='Fill out the Core Questionnaire'
        />
      );

  return (
    <Container>
      <Title>Other comorbidities</Title>
      <Description>
        PKD is a systemic disease and can affect organs other than the kidneys.
        Track your other health issues and talk to your doctor about whether
        they could be related to your PKD
      </Description>
      {content}
    </Container>
  );
};

export default OtherComorbidities;
